(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-custom"]) return;
  try {
    
  (function () {
    function initFooterAccordions() {
      document.querySelectorAll('.fc-accordion__btn').forEach(function (btn) {
        if (btn.dataset.fcInit) return;
        btn.dataset.fcInit = '1';

        btn.addEventListener('click', function () {
          var body = btn.nextElementSibling;
          var icon = btn.querySelector('.fc-accordion__icon');
          var isOpen = btn.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            body.style.maxHeight = '0';
            icon.textContent = '+';
            btn.setAttribute('aria-expanded', 'false');
          } else {
            body.style.maxHeight = body.scrollHeight + 'px';
            icon.textContent = '−';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFooterAccordions);
    } else {
      initFooterAccordions();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
